import React from 'react';
import { Snackbar, Box, Typography, Button, IconButton, Paper, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { NotificationAvatar } from './notificationPresentation';

function SlideDown(props) {
  return <Slide {...props} direction="down" />;
}

/**
 * Aviso que acabou de chegar: providências (paciente cancelou, pediu reagendamento,
 * consultas sem confirmação) e o paciente confirmou ou remarcou pelo link.
 * Some sozinho em 8 s; "Abrir" leva ao link do aviso. O Header remonta o toast a cada
 * aviso (key) para cada um da fila ter os seus 8 s.
 */
function NotificationToast({ item, onClose, onMarkRead }) {
  const navigate = useNavigate();

  const handleOpen = () => {
    if (item && !item.is_read) onMarkRead([item.id]);
    onClose();
    if (item && item.link) navigate(item.link);
  };

  return (
    <Snackbar
      open={Boolean(item)}
      onClose={(event, reason) => {
        if (reason === 'clickaway') return;
        onClose();
      }}
      autoHideDuration={8000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      TransitionComponent={SlideDown}
      sx={{ zIndex: 1400, mt: { xs: 0, md: 1 } }}
    >
      <Paper
        elevation={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 1.5,
          pr: 1,
          width: 360,
          maxWidth: 'calc(100vw - 24px)',
          borderRadius: '12px',
          borderLeft: '4px solid var(--color-primary)',
        }}
      >
        {item && <NotificationAvatar type={item.type} size={36} />}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'var(--color-text-dark)', lineHeight: 1.3 }}>
            {item?.title}
          </Typography>
          {item?.body && (
            <Typography
              variant="body2"
              sx={{
                color: 'var(--color-text-medium)',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {item.body}
            </Typography>
          )}
        </Box>
        {item?.link && (
          <Button size="small" onClick={handleOpen} sx={{ textTransform: 'none', flexShrink: 0 }}>
            Abrir
          </Button>
        )}
        <IconButton size="small" onClick={onClose} aria-label="Fechar">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Paper>
    </Snackbar>
  );
}

export default NotificationToast;
